import { ArrowRight, Loader2 } from "lucide-react";
import { Button } from "@/components/atoms/studio/ui/button";
import { WeaveIcon } from "../atoms/WeaveIcon";

interface Props {
  improving: boolean;
  onImprove: () => void;
}

export function ImproveInMultiAgentCTA({ improving, onImprove }: Props) {
  return (
    <div className="flex items-center gap-4 rounded-xl border border-border bg-card px-5 py-4">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10">
        <WeaveIcon className="h-4 w-4 text-primary" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-foreground">Not satisfied with the results?</p>
        <p className="text-xs text-muted-foreground mt-0.5">
          Weave us together — send this report to Weave for deeper analysis and targeted improvements.
        </p>
      </div>
      <Button
        type="button"
        variant="default"
        size="sm"
        onClick={onImprove}
        disabled={improving}
        className="shrink-0 gap-1.5"
      >
        {improving ? (
          <>
            <Loader2 className="h-3.5 w-3.5 animate-spin" />
            <span>Weaving in…</span>
          </>
        ) : (
          <>
            <span>Let's Weave</span>
            <ArrowRight className="h-3.5 w-3.5" />
          </>
        )}
      </Button>
    </div>
  );
}
